import { Button, buttonStyle } from 'components/button/Button';
import { defaultButtonStyle } from 'components/button/DefaultButton';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { tokens } from 'styles/tokens';

export const LinkButton = styled.a`
    ${buttonStyle}
    ${defaultButtonStyle}

    display: inline-block;
    text-decoration: none;
`;

export const menuButtonStyles = css<{ $active?: boolean }>`
    width: 4.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    /* take the full top-to-bottom of the top bar */
    align-self: stretch;

    color: ${(props) =>
        props.$active ? tokens.icon.actionSelected : tokens.icon.actionActive};

    border-radius: 0;
    border-top: 2px solid transparent; /* centering, complementing bottom */
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: ${(props) =>
        props.$active ? tokens.primary.default : 'transparent'};

    &:hover {
        border-bottom-color: ${(props) =>
            props.$active ? tokens.primary.default : tokens.nav.border};
        color: ${(props) =>
            props.$active ? tokens.icon.actionSelected : tokens.icon.actionHover};
    }

    &:active,
    /* we sometimes use the 'active' class name, but react router will use this
     * when a link is active (the current page), which is different from how we
     * use it ("enabled"), so opt-out for anchor elements
     */
    &:not(a).active {
        border-bottom-color: ${tokens.primary.dark};
        color: ${tokens.icon.actionSelected};
    }
`;

export const MenuLink = styled(NavLink)<{
    $padding?: string;
    $active?: boolean;
    $fitContent?: boolean;
}>`
    ${menuButtonStyles}
    ${(props) => props.$fitContent && css`width: fit-content;`}
`;

export const MenuButton = styled(Button)<{ $active?: boolean }>`
    ${menuButtonStyles}
`;
